/* global FB */

// Decorator for facebook functions. Ensures that version number can
// be easily changed.

const PERMISSIONS = ['email'];

const SDK_SELECTOR = '#facebook-jssdk';

/**
 * @returns {HTMLElement}    the script tag that loads facebook
 */
function getScriptElement() {
  return document.querySelector(SDK_SELECTOR);
}

/**
 * @returns {Boolean}
 */
function isLoaded() {
  return typeof FB === 'object';
}

/**
 * @param {Function} onResponse     callback to pass into the SDK.
 */
export function login(onResponse) {
  const scope = PERMISSIONS.join(',');
  FB.login(onResponse, { scope });
}

/**
 * Currently expects rails to load facebook tag in the layout. Will
 * return a promise once the script has loaded.
 *
 * TODO: Once all requests that require facebook are running
 * on the javascript side, handle the loading entirely using this method.
 *
 * @returns {Promise}
 */
export function load() {
  if (isLoaded()) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const element = getScriptElement();

    if (!element) {
      reject();
    }

    element.addEventListener('load', resolve);
    element.addEventListener('error', reject);
  });
}

export default Object.freeze({ load, login });
